import axios from "axios";
import api from "../axiosConfig";

const API_URL = "/reportes";

export const fetchDashboard = async () => {
  const res = await api.get(`${API_URL}/dashboard`);
  return res.data;
};

export const fetchPagosPorMes = async () => {
  const res = await api.get(`${API_URL}/finanzas/pagos-por-mes`);
  return res.data.data;
};

export const fetchMembretesPorEstado = async () => {
  const res = await api.get(`${API_URL}/membretes/por-estado`);
  return res.data.data;
};

export const fetchDeudasDetalle = async (skip = 0, limit = 50, cliente = "") => {
  const res = await api.get(`${API_URL}/deudas-detalle`, {
    params: { skip, limit, cliente },
  });
  return res.data.data;
};
